export const FETCH_HOTEL_ONLY_FILTERS = "FETCH_HOTEL_ONLY_FILTERS";
export const FETCH_HOTEL_ONLY_FILTERS_SUCCESS = "FETCH_HOTEL_ONLY_FILTERS_SUCCESS";
export const SEND_ESTIMATE_HOTELONLY = "SEND_ESTIMATE_HOTELONLY";
